// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2L1aP","messages":"Chat_messages__23Rnk","dateDivider":"Chat_dateDivider__vtXaC"};